class Dropdown {

  constructor( el ) {
    this.el = el;
    this.openClass = 'is-open';
    this.trigger = this.el.querySelector('.dropdown__selected-option');
    this.options = this.el.querySelector('.dropdown__options');
    this.default = this.el.querySelector('[data-default]') || null;

    this.bindEvents();

    if ( this.default ) {
      this.setDefault();
    }
  }

  open() {
    this.el.classList.add( this.openClass );
  }

  close() {
    this.el.classList.remove( this.openClass );
  }

  handleClick() {
    if ( this.el.classList.contains( this.openClass ) ) {
      this.close();
      return;
    }
    this.open();
  }

  updateSelected( e ) {
    const currentSelected = this.trigger.querySelector('.dropdown__label');
    const newSelected = e.target;

    currentSelected.innerText = newSelected.innerText;
    this.close();
  }

  setDefault() {
    const currentSelected = this.trigger.querySelector('.dropdown__label');
    const newSelected = this.default;

    currentSelected.innerText = newSelected.innerText;
    this.close();
  }

  bindEvents() {
    this.trigger.addEventListener( 'click', this.handleClick.bind( this ) );
    this.options.addEventListener( 'click', this.updateSelected.bind( this ) );
  }

}

function init() {
  const listener = window.hasOwnProperty('ontouchstart')
    ? 'touchstart' : 'click';
  const dropdowns = document.querySelectorAll('[data-dropdown]');

  // init any dropdowns on page
  dropdowns.forEach( el => new Dropdown( el ) );

  // listen for clicks outside to close
  document.addEventListener( listener, ( e ) => {
    let targetEl = e.target;
    do {
      if ( targetEl.dataset && targetEl.dataset.hasOwnProperty('dropdown') ) {
        return;
      } else {
        targetEl = targetEl.parentNode;
      }
    } while ( targetEl );

    dropdowns.forEach( el => el.classList.remove('is-open') );

  });
}


init();

export default undefined;
